(function(global) {
    'use strict';
    
    var lib = global.lib || (global.lib = {}),
        cjs = global.createjs || (global.createjs = {}),
        mms = global.mms || (global.mms = {});
  
    function Screen() {
        this.__parent__.apply(this, arguments);

        this.autoReset = false;
        this.stop();
        
        this.on("added", this._added, this);
    }
    Screen.TWEEN_DURATION = 1;
    Screen.prototype = {
        _added: function() {
            this._addListeners();
        },
        _addListeners: function() {
            this._addClickEvent();
            mms.state.signals.changePainting.add(this._changePainting, this);
            mms.state.signals.changeInfo.add(this._changeInfo, this);
        },
        _addClickEvent: function() {
            this.on("click", this._click, this);
        },
        _removeClickEvent: function() {
            while (this._listeners.click) {
                this.off("click", this._listeners.click[0]);
            }
        },
        _click: function() {
            mms.state.setPainting(this.painting);
            if (this.painting === mms.state.painting) {
                mms.sounds.click();
            }
        },
        _changePainting: function(prevValue) {
            if (mms.state.painting === this.painting || prevValue === this.painting) {
                this._removeClickEvent();
                this.parent.setChildIndex(this, this.parent.numChildren - 1);
                mms.state.setTweening(mms.State.TWEEN_SCREEN);
                var self = this,
                    onComplete = function() {
                        mms.state.setTweening('');
                        if (!mms.state.painting) {
                            self._addClickEvent();
                        }
                    };
                if (mms.state.painting) {
                    TweenLite.to(this, Screen.TWEEN_DURATION, {
                        easel: {frame: this.timeline.resolve("in")},
                        ease:Linear.easeNone,
                        onComplete: onComplete
                    });
                }
                else {
                    TweenLite.to(this, Screen.TWEEN_DURATION, {
                        easel:{frame: this.timeline.resolve("out")},
                        ease:Linear.easeNone,
                        onComplete: onComplete
                    });
                }
            }
        },
        _changeInfo: function(value) {
            if (this.painting === mms.state.painting) {
                mms.state.setTweening(mms.State.TWEEN_INFO);
                var onComplete = function() {
                    mms.state.setTweening('');
                };
                if (value) {
                    TweenLite.to(this, 0.75, {
                        easel: {frame: this.timeline.resolve("info")},
                        ease:Linear.easeNone,
                        onComplete: onComplete
                    });
                }
                else {
                    TweenLite.to(this, 0.75, {
                        easel:{frame: this.timeline.resolve("in")},
                        ease:Linear.easeNone,
                        onComplete: onComplete
                    });
                }
            }
        }
    };
    
    var SwipeUp = _.extend({}, cjs.TouchMixin, {
        _addListeners: function() {
            Screen.prototype._addListeners.apply(this, arguments);
            this.initTouch();
        },
        onSwipeUp: function(touch1, touch2) {
            if (touch1[0].stageY > (this.stage.canvas.height - this.getSwipeThreshold()) && !mms.state.info && mms.state.buttonsEnabled) {
                mms.state.setInfo(true);
            }
        }
    });

    lib.Screen1 = cjs.extend2(lib.Screen1, Screen, _.extend({}, SwipeUp, {
        painting: 1
    }));
    lib.Screen2 = cjs.extend2(lib.Screen2, Screen, _.extend({}, SwipeUp, {
        painting: 2
    }));
    lib.Screen3 = cjs.extend2(lib.Screen3, Screen, _.extend({}, SwipeUp, {
        painting: 3
    }));
    
    mms.Screen = Screen;
    
})(this);